import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const EditUserSchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'O uuid do usuário é obrigatório' }),
  name: T.String({ format: 'fullname', error: 'Campo obrigatório' }),
  phone: T.Intersect([
    T.String({ error: 'Número de telefone é um campo obrigatório' }),
    T.String({ format: 'mobile', error: 'O formato é inválido' }),
  ]),
  email: T.Intersect([
    T.String({ error: 'O campo email é obrigatório' }),
    T.String({ format: 'email', error: 'O formato é inválido' }),
  ]),
  registration: T.Optional(T.String({ minLength: 0, error: 'Matrícula deve ter pelo menos 1 caractere' })),
  role: T.String({ format: 'uuid', error: 'Cargo é um campo obrigatório' }),
  responsibleUser: T.String({ format: 'uuid', error: 'Responsável direto é um campo obrigatório' }),
  active: T.Boolean({ error: 'Status é obrigatório' }),
  tenantUuid: T.Optional(T.String({ format: 'uuid', error: 'Aplicação inválida' })),
});
// TODO tratar validação para admin, quando responsibleUser não é necessário. Ou ainda, colocar uma flag na tabela indicando que é o primeiro user do tenant

export type EditUserInputType = typeof EditUserSchema.static;

export async function ValidateEditUserInput(value: unknown): Promise<EditUserInputType> {
  return Value.Parse(EditUserSchema, value);
}

export function checkUserEditInput(field: string, value: unknown): string | boolean {
  return validateField(EditUserSchema, field, value);
}
